import React from "react";
import pure from "recompose/pure";
import { SvgIcon } from "@material-ui/core";

let CompaniesIcon = ({ ...props }) => (
  <SvgIcon {...props}>
    <path d="M4.5 28.5V8.55003C4.49991 8.24211 4.59458 7.94163 4.77115 7.68938C4.94773 7.43713 5.19766 7.24533 5.487 7.14003L19.9935 1.86603C20.1068 1.82478 20.2284 1.81148 20.348 1.82723C20.4675 1.84298 20.5815 1.88732 20.6803 1.95651C20.7791 2.02569 20.8597 2.11767 20.9153 2.22464C20.971 2.33162 21 2.45044 21 2.57103V10.0005L30.474 13.158C30.7728 13.2576 31.0327 13.4486 31.2169 13.7041C31.401 13.9596 31.5001 14.2666 31.5 14.5815V28.5H34.5V31.5H1.5V28.5H4.5ZM7.5 28.5H18V5.78253L7.5 9.60153V28.5ZM28.5 28.5V15.663L21 13.1625V28.5H28.5Z" />
  </SvgIcon>
);
CompaniesIcon = pure(CompaniesIcon);
CompaniesIcon.displayName = "AccountIcon";
CompaniesIcon.muiName = "SvgIcon";

export default CompaniesIcon;
